module.exports = __webpack_public_path__ + "img/screen&eye.441c59f6.png";